import type { GroupedPosition } from '../reducer/positions.reducer'
import { getSecurityKey } from './security'

export const computeBasketStrategyMtm = (
    position: GroupedPosition,
    ltpsByKey: Map<string, number>
): number => {
    const { security, realizedProfit, quantity, children = [] } = position
    const pm = security.priceMultiplier ?? 100
    if (quantity === 0) {
        return realizedProfit / pm
    }
    let profit = realizedProfit
    children.forEach((childPos) => {
        const childSecKey = getSecurityKey(childPos.security.exchange, childPos.security.code)
        const ltp = ltpsByKey.get(childSecKey) ?? 0
        profit += (ltp - childPos.avgPrice) * childPos.quantity
    })
    return profit / pm
}
